module.exports = __webpack_public_path__ + "static/img/coin_1.424d275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/guide/coin_1.png
// module id = 4mf3
// module chunks = 4